import { ListItem } from "./list-Item.model";

export class FieldMapping {
    name: string;
    field_type: string;
    field_ID: number;
    data_type: string;
    system_name: string;
    record_type: string;
    list_items: Array<ListItem>;
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/field-mapping.model.ts